"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTradeStateToByte = exports.getTradeSellerAddressOffset = exports.getTradeBuyerAddressOffset = exports.getTradeStateOffSet = void 0;
const types_1 = require("../types");
const bytes_1 = require("@project-serum/anchor/dist/cjs/utils/bytes");
const getTradeStateOffSet = () => {
    return (8 + // DISCRIMINATOR
        8 + // order id
        8 + // order id seed
        1 + // side
        1);
};
exports.getTradeStateOffSet = getTradeStateOffSet;
const getTradeBuyerAddressOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // order id
        8 + // order id seed
        1 + // side
        1 + // bond type
        1 + // trade state
        32 + // escrow config
        32 + // seller address
        32 // seller token acount
    );
};
exports.getTradeBuyerAddressOffset = getTradeBuyerAddressOffset;
const getTradeSellerAddressOffset = () => {
    return (8 + // DISCRIMINATOR
        8 + // order id
        8 + // order id seed
        1 + // side
        1 + // bond type
        1 + // trade state
        32 // escrow config
    );
};
exports.getTradeSellerAddressOffset = getTradeSellerAddressOffset;
const mapTradeStateToByte = (orderState) => {
    let orderStateIntValue;
    switch (orderState) {
        case types_1.OrderState.Awaiting:
            orderStateIntValue = 0;
            break;
        case types_1.OrderState.Deposited:
            orderStateIntValue = 1;
            break;
        case types_1.OrderState.Disputed:
            orderStateIntValue = 2;
            break;
        case types_1.OrderState.Released:
            orderStateIntValue = 3;
            break;
        case types_1.OrderState.Canceled:
            orderStateIntValue = 4;
            break;
        default:
            orderStateIntValue = 0;
    }
    let value = bytes_1.bs58.encode(Buffer.from([orderStateIntValue]));
    return value;
};
exports.mapTradeStateToByte = mapTradeStateToByte;
